module.exports = __webpack_public_path__ + "static/media/mediation.3b63d930.png";